module.exports = __webpack_public_path__ + "img/虎掌南星.ffab70ac.jpg";